import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "top_left", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 6 6", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("path", { fill: "#FFF", stroke: "red", d: "M2.5 2.5v2a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-2z" }));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
